// BL621 Phase 3 (Decision 042 §"Mode 4 — Debug") — `grid debug ssh <entity>`.
//
// The folder-rooted top-level `ssh` shells into the cwd entity (no argument).
// `debug ssh <entity-slug>` is the explicit-target sibling: it requires an
// entity slug/id so you can shell into an arbitrary entity from anywhere. Both
// share the same server-side exec endpoint and TTY plumbing in `../ssh.js`.

import { Command } from 'commander';
import { Command as CommanderCommand } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { readCredentials } from '../../credentials.js';
import { loadConfig } from '../../config.js';
import { runSsh, realConnect } from '../ssh.js';

export const debugSshCommand: CommanderCommand = new Command('ssh')
  .description('Open a shell in an arbitrary entity by slug (non-cwd target).')
  .argument('<entity>', 'Entity slug or id to shell into')
  .option('--service <name>', 'Service name (defaults to the first running pod)')
  .action(async (entity: string, opts: { service?: string }) => {
    try {
      const creds = readCredentials();
      const cfg = loadConfig();
      const client = await getV2Client();
      await runSsh({
        client,
        name: entity,
        service: opts.service,
        jwt: creds?.jwt ?? '',
        apiUrl: cfg.api_url,
        connect: realConnect,
      });
    } catch (err) {
      await handleV2Error(err);
    }
  });
